export function setupBackgroundMessaging() {
  // Only import React Native Firebase on mobile platforms
  if (typeof window === "undefined" || !window.navigator) {
    // React Native environment
    try {
      const messaging = require("@react-native-firebase/messaging").default;

      // Register background message handler for React Native Firebase
      messaging().setBackgroundMessageHandler(async (remoteMessage: any) => {
        console.log("Background message received:", remoteMessage);

        // Handle background message here
        // You can perform tasks like updating local storage,
        // triggering background sync, etc.

        // Return a promise to indicate the message was handled
        return Promise.resolve();
      });
    } catch (error) {
      console.log("React Native Firebase not available:", error);
    }
  }
}
